import { VersionHistoryPanel } from './VersionHistoryPanel';

export const VersionHistoryTabContent = () => (
  <div className="@VersionHistoryTabContent h-full overflow-auto">
    <VersionHistoryPanel />
  </div>
);
